export function GameCardSkeleton() {
  return <div className="aspect-square rounded-xl bg-surface-container animate-pulse" />;
}
